<template>
    <div class="upload-tool popup">
        <div class="s-content">
            <div class="head">{{title}}</div>
            <div class="body">
                <div class="wrap">
                    <div :class="['drag',{da:da}]" @dragover.prevent="da=true" @dragenter.prevent="da=true" @dragleave.prevent="da=false" @dragend.prevent="da=false" @drop.prevent="da=false;dropFiles($event)">
                        <div class="imgs">
                            <img src="../assets/images/upload/file.png" class="add">
                            <div class="fade"></div>
                        </div>
                        <p class="help">拖动文件至此或<label>选择一个文件<input type="file" :multiple="!single" @change="selectImage($event)"></label>以上传</p>
                        <p class="requirement" v-if="types.length">{{types.join("、")}}格式，最大文件大小：4MB</p>
                        <p class="requirement" v-else>{{types.join("、")}}最大文件大小：4MB</p>
                    </div>
                    <div class="desc" v-if="desc">
                        <div class="droplist">
                            <strong class="required" v-if="checkRequired">*</strong>
                            <drop-down width="100%" :data="checkList" name="label" v-model="checkData" :check="checkData" :placeholder="checkPlaceholder" v-if="checkList.length" all="不选择" :required="checkRequired"></drop-down>
                        </div>
                        <span>{{desc}}</span>
                    </div>
                </div>
                <table class="uploaded" v-if="historyCloned.length||selectedImages.length">
                    <tbody>
                        <tr v-for="(i,index) in historyCloned" :key="'history'+index">
                            <td colspan="5">{{i.split("?name=").length==2?i.split("?name=")[1]:i}}</td>
                            <td width="80px">
                                <div class="actions">
                                    <button class="view" v-image="[i.uploadedUrl]"></button>
                                    <button @click="delHistory(i,index)"></button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody>
                        <tr v-for="(i,index) in selectedImages" :key="'selected'+index">
                            <td width="40px">
                                <img src="../assets/images/upload/image.png">
                            </td>
                            <td>{{i.file.name}}</td>
                            <td>{{i.file.type.split("/").pop().toUpperCase()}}</td>
                            <td>{{(i.file.size<=1024*1024)?((i.file.size/1024).toFixed(1)+'KB'):((i.file.size / (1024 * 1024)).toFixed(1) + "MB" )}}</td> <td>
                                    <div :class="['progress',{done:i.uploaded,error:i.error}]">
                                        <div class="graph" :style="{width:i.progress+'%'}"></div>
                                    </div>
                            </td>
                            <td width="80px">
                                <div class="actions" v-if="i.uploaded">
                                    <button class="view" v-image="[i.uploadedUrl]"></button>
                                    <button @click="selectedImages.splice(index,1)"></button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="action-bts">
                    <button class="action-bt" @click="$emit('close')">关闭</button>
                    <button v-if="!manual" class="action-bt main" @click="$emit('output',availImages);$emit('confirm',images);$emit('close');checkList.length&&$emit('check',checkData)" :disabled="required.main.length>0||noEmpty&&history.length+images.length==0||checkRequired==true&&(!checkData)">确定</button>
                    <button v-else class="action-bt main" @click="startUpload" :disabled="unuploaded==0">开始导入</button>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="less">
    .upload-tool {
        .s-content {
            width: 800px;
            overflow: hidden;
        }

        .head {
            background-color: transparent;
            color: #353535;
            border-bottom: 1px solid #dfe2e7;
            justify-content: center;
            font-size: 20px;
            font-weight: bold;
        }

        .body {
            padding: 0;

            .wrap {
                display: flex;
                padding: 30px;

                &+.action-bts {
                    padding-top: 0;
                }



                .drag {
                    border: 2px dashed #c0c9d0;
                    border-radius: 4px;
                    background-color: #f9fafc;
                    flex: 1;
                    padding-bottom: 5px;

                    &.da {
                        background-color: #f1f1f1;
                    }

                    .imgs {
                        height: 150px;
                        position: relative;

                        .add {
                            position: absolute;
                            left: calc(50% - 16px);
                            bottom: 24px;
                            z-index: 20;
                        }

                        .fade {
                            position: absolute;
                            opacity: .13;
                            filter: grayscale(1);
                            left: calc(50% - 32px);
                            bottom: 10px;
                            z-index: 10;
                            border: 2px dashed gray;
                            width: 60px;
                            height: 64px;
                        }
                    }

                    .help {
                        margin: 0;
                        padding: 10px 20px;
                        font-size: 19px;
                        letter-spacing: 1px;
                        text-align: center;
                        margin-bottom: 50px;

                        label {
                            color: #02c0a7;
                            cursor: pointer;
                            text-decoration: underline;

                            input {
                                display: none;
                            }
                        }
                    }

                    .requirement {
                        color: #8d99a5;
                        margin: 0;
                        font-size: 17px;
                        text-align: center;
                    }

                }

                .desc {
                    padding: 10px 0 10px 20px;
                    font-size: 17px;
                    margin: 0;
                    color: #60717b;
                    width: 340px;
                }
            }

            .droplist {
                display: flex;
                align-items: center;
                margin-bottom: 15px;

                .required {
                    margin-right: 6px;
                    font-size: 22px;
                }

                .drop-down {
                    border-color: #01bfa6;
                    flex: auto;


                    &:hover {}

                    dt,
                    li {
                        font-size: 15px;
                        color: #60717b;
                    }
                }
            }

            table.edit {
                td {
                    font-size: 17px;

                    dt {
                        font-size: 17px !important;
                    }
                }
            }

            table.uploaded {
                border-top: 1px solid #f6f6f6;
                width: 100%;
                color: #60717b;

                td {
                    padding-top: 15px;
                    padding-bottom: 15px;
                    background-color: #fdfdfd;
                    border-bottom: 1px solid #f6f6f6;
                    padding-right: 15px;

                    &:nth-child(1) {
                        padding-left: 20px;
                    }

                    .progress {
                        width: 90px;
                        height: 15px;
                        background-color: #f7f7f7;
                        overflow: hidden;
                        border-radius: 3px;

                        .graph {
                            width: 80%;
                            height: 100%;
                            background-image: url(../assets/images/upload/progress.png);
                            background-size: auto 100%;
                            animation: forward 3600s infinite linear;
                        }

                        &.done {
                            .graph {
                                background-image: url(../assets/images/upload/done.png);
                                background-repeat: no-repeat;
                                background-position: center;
                                animation: none;
                                background-color: #02c0a7;
                            }
                        }

                        &.error {
                            background-color: #d20;
                            background-image: url(../assets/images/upload/error.png);
                            background-repeat: no-repeat;
                            background-position: center;

                            .graph {
                                display: none;
                            }
                        }
                    }
                }

                @keyframes forward {
                    from {
                        background-position: left;
                    }

                    to {
                        background-position: 150000px;
                    }
                }

                .actions {
                    display: flex;
                    justify-content: center;

                    a,
                    button {
                        width: 35px;
                        height: 35px;
                        border: none;
                        background-color: transparent;
                        background-position: center;
                        background-repeat: no-repeat;

                        &:hover {
                            opacity: .6;
                        }
                    }

                    .view {
                        background-image: url(../assets/images/upload/preview.png);
                        margin-right: 10px;

                    }

                    button {
                        background-image: url(../assets/images/upload/del.png);
                    }
                }
            }

            .action-bts {
                padding: 20px 0;

                .action-bt {
                    font-size: 19px;
                    padding: 6px 20px;
                    height: auto;
                    border-radius: 5px;
                    color: #4099d3;
                    border-color: #4099d3;

                    &:hover {
                        opacity: .8;
                    }

                    &.main {
                        color: white;
                        background-color: #4099d3;
                        transition: all .15s;


                    }
                }
            }
        }
    }
</style>

<script>
    export default {
        props: {
            title: {
                default: "图片上传"
            },
            desc: {
                default: ""
            },
            api: {
                default: ""
            },
            single: {
                default: false
            },
            checkList: {
                default () {
                    return []
                }
            },
            checkPlaceholder: {
                default: "请选择"
            },
            types: {
                default () {
                    return []
                }
            },
            history: {
                default () {
                    return []
                }
            },
            delApi: {
                default: "/businessOpportunities/delete/photo"
            },
            customerId: {},
            onlyClose: {
                default: false
            },
            checked: {},
            delType: {},
            noEmpty: {
                default: true
            },
            noDelete: {
                default: false
            },
            manual: {
                default: false
            },
            businessId: {
                default: undefined
            },
            checkRequired: {
                default: false
            }
        },
        data() {
            return {
                draggable: (('draggable' in document.body) || ('ondragstart' in document.body && 'ondrop' in
                    document.body)) && 'FormData' in window && 'FileReader' in window,
                selectedImages: [],
                da: false,
                checkData: undefined,
                historyCloned: []
            }
        },
        methods: {
            dropFiles: function (e) {
                this.selectImage({
                    target: {
                        files: e.dataTransfer.files
                    }
                });
            },
            delHistory(url, index) {
                var that = this;
                this.$root.confirm.push({
                    text: "确定删除该记录？",
                    fn() {
                        return ajax.call(that, {
                            url: that.delApi + "?url=" + encodeURIComponent(url) + "&customerId=" + that.customerId + "&type=" + that.delType + "&businessId=" + that.businessId,
                            type: "delete",
                            s() {
                                that.historyCloned.splice(index, 1);
                            }
                        });

                    }
                });
            },
            selectImage: function (e) {
                var that = this;
                var files = [];
                $.each(e.target.files, (index, item) => {
                    files.push(item);
                });
                if (e.target.files.length > 0) {
                    if (files.filter((v) => {
                            return that.types.indexOf(v.name.split('.').pop().toLowerCase()) == -1
                        }).length > 0 && that.types.length > 0) {
                        that.$root.alert.push("文件格式不正确！");
                        return true;
                    }
                    if (files.filter((v) => {
                            return v.size > 4 * 1024 * 1024
                        }).length > 0) {
                        that.$root.alert.push("文件不能大于4MB！");
                        return true;
                    }
                    if (this.single) {
                        this.selectedImages = [{
                            file: e.target.files[0],
                            fileName: e.target.files[0].name,
                            blob: URL.createObjectURL(e.target.files[0]),
                            progress: 0,
                            uploadedUrl: null,
                            uploading: false,
                            uploaded: false,
                            selected: false
                        }]
                    } else {
                        for (let i = 0; i < e.target.files.length; i++) {
                            this.selectedImages.push({
                                file: e.target.files[i],
                                fileName: e.target.files[i].name,
                                blob: URL.createObjectURL(e.target.files[i]),
                                progress: 0,
                                uploadedUrl: null,
                                uploading: false,
                                uploaded: false,
                                selected: false
                            });
                        }
                    }
                    this.$emit("change", e);
                    !this.manual && this.startUpload();
                }
            },
            startUpload: function () {
                var that = this;
                $.each(this.selectedImages, function (index, item) {
                    if (item.uploaded || item.uploading) return;
                    item.uploading = true;
                    var fd = new FormData();
                    fd.append("file", item.file);
                    ajax.call(that, {
                        url: that.api,
                        type: "post",
                        data: fd,
                        processData: false,
                        contentType: false,
                        xhr() {
                            var xhr = new XMLHttpRequest();
                            xhr.upload.addEventListener("progress", function (e) {
                                item.progress = (e.loaded / e.total) * 100;
                            });
                            return xhr;
                        },
                        success(res) {
                            if (res.code === 0) {
                                item.uploaded = true;
                                item.uploadedUrl = res.data;
                                that.select(item);
                                if (that.fileMode == false) {
                                    that.historyImages.push({
                                        url: res.data,
                                        selected: false
                                    });
                                }
                            } else {
                                that.$set(item, "error", true);
                            }
                            that.$emit("response", res);
                        },
                        error(err) {
                            that.$set(item, "error", true);
                            that.$emit("error", err);
                        }
                    });
                });
            },
            select: function (obj) {
                if (this.single) {
                    $.each(this.files, function (index, item) {
                        if (item != obj) {
                            item.selected = false;
                        }
                    });
                    $.each(this.selectedImages, function (index, item) {
                        if (item != obj) {
                            item.selected = false;
                        }
                    });
                    $.each(this.historyImages, function (index, item) {
                        if (item != obj) {
                            item.selected = false;
                        }
                    });
                }
                obj.selected = !obj.selected;
            }
        },
        computed: {
            unuploaded: function () {
                var ret = 0;
                $.each(this.selectedImages, function (index, item) {
                    if (item.uploaded == false && item.error != true) {
                        ret++
                    }
                });
                return ret;
            },
            uploaded: function () {
                var ret = 0;
                $.each(this.files, function (index, item) {
                    if (item.uploadedUrl) {
                        ret++;
                    }
                });
                return ret;
            },
            uploadedLength: function () {
                var ret = 0;
                $.each(this.selectedImages, function (index, item) {
                    if (item.uploaded) {
                        ret++;
                    }
                });
                return ret;
            },
            totalSize: function () {
                var size = 0;
                $.each(this.files, function (index, item) {
                    size += item.file.size;
                });
                $.each(this.selectedImages, function (index, item) {
                    size += item.file.size;
                });
                if (size < 1024 * 1024) {
                    return (size / 1024).toFixed(1) + "KB";
                } else {
                    return (size / (1024 * 1024)).toFixed(1) + "MB"
                }
            },
            availImages() {
                var ret = [];
                this.selectedImages.forEach((item) => {
                    item.uploadedUrl && ret.push(Object.assign({
                        file: item.file
                    }, item));
                });
                return ret;
            },
            images: function () {
                var ret = [];
                $.each(this.availImages, function (index, item) {
                    // item.uploadedUrl && ret.push(item.uploadedUrl + "?name=" + encodeURIComponent(item.fileName));
                    item.uploadedUrl && ret.push(item.uploadedUrl);
                });
                return ret;
            }
        },
        mounted() {
            this.historyCloned = this.history.clone();
        },
        watch: {
            checked(after) {
                this.checkData = after;
            }
        }
    }
</script>